import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAppointmentModal } from '../context/AppointmentModalContext';
import LanguageSwitch from './LanguageSwitch';
import { useI18n } from '../i18n/I18nContext';
import { homePath } from '../i18n/paths';
import './BurgerMenu.css';

function BurgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { openModal } = useAppointmentModal();
  const { lang, copy } = useI18n();
  const home = homePath(lang);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    // Prevent scrolling when menu is open
    document.body.style.overflow = isOpen ? 'auto' : 'hidden';
  };

  const closeMenu = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  const handleScrollToTop = (e) => {
    e.preventDefault();
    closeMenu();
    
    if (location.pathname !== home) {
      navigate(home);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleScrollToSection = (sectionId) => (e) => {
    e.preventDefault();
    closeMenu();
    const hash = sectionId.startsWith('#') ? sectionId : `#${sectionId}`;
    const scroll = () => {
      const element = document.querySelector(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };

    if (location.pathname !== home) {
      navigate(`${home}${hash}`);
      setTimeout(scroll, 100);
    } else {
      navigate(`${home}${hash}`, { replace: true });
      scroll();
    }
  };

  return (
    <div className="burger-menu">
      <button 
        className={`burger-button ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label={isOpen ? copy.nav.close : copy.nav.menu}
      >
        <span className="burger-line"></span>
        <span className="burger-line"></span>
        <span className="burger-line"></span>
      </button>

      <div className={`burger-overlay ${isOpen ? 'open' : ''}`} onClick={closeMenu}>
        <div className="burger-content" onClick={e => e.stopPropagation()}>
          <nav className="burger-nav">
            <LanguageSwitch className="michaela-lang-switch-menu" onNavigate={closeMenu} />
            <a href={home} className="burger-nav-link" onClick={handleScrollToTop}>{copy.nav.home}</a>
            <Link to={lang === 'en' ? '/en/about' : '/ueber-mich'} className="burger-nav-link" onClick={closeMenu}>{copy.nav.about}</Link>
            <Link to={lang === 'en' ? '/en/services' : '/leistungen'} className="burger-nav-link" onClick={closeMenu}>{copy.nav.services}</Link>
            <a href="#raeume" className="burger-nav-link" onClick={handleScrollToSection('#raeume')}>{copy.nav.approach}</a>
            <Link to={lang === 'en' ? '/en/insights' : '/impulse'} className="burger-nav-link" onClick={closeMenu}>{copy.nav.insights}</Link>
            <Link to={lang === 'en' ? '/en/testimonials' : '/stimmen'} className="burger-nav-link" onClick={closeMenu}>{copy.nav.testimonials}</Link>
            <Link to={lang === 'en' ? '/en/contact' : '/kontakt'} className="burger-nav-link" onClick={closeMenu}>{copy.nav.contact}</Link>
            <button
              onClick={(e) => {
                e.preventDefault();
                closeMenu();
                openModal();
              }}
              className={`burger-nav-link burger-nav-link-special${lang === 'en' ? ' is-en' : ''}`}
            >
              {copy.nav.cta}
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default BurgerMenu;
